module.exports = __webpack_public_path__ + "static/media/cookedmeat.b10083c9.webp";